import { render, staticRenderFns } from "./QuotePageLayout.vue?vue&type=template&id=1f281c91&scoped=true&"
import script from "./QuotePageLayout.vue?vue&type=script&lang=ts&"
export * from "./QuotePageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./QuotePageLayout.vue?vue&type=style&index=0&id=1f281c91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f281c91",
  null
  
)

export default component.exports